import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import {
    Grid,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Chip from '@material-ui/core/Chip';
import LoyaltyOutlinedIcon from '@material-ui/icons/LoyaltyOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import LearningContentsContext from '../../../context/learningContentContext/learningContents-context';
import { Coin } from '../../shared/component';

import useStyles from '../../../styles/components/learningcontent/stylesLCOthers'
import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper';
import { getLearningContentLevel, setLearningContentSession, removeLearningContentFromSession } from '../../../utils/helpers/others/SessionHelper';

const LearningContentsHolder = () => {
    const classes = useStyles()
    const history = useHistory();
    const { learningContentsContext } = useContext(LearningContentsContext);
    const learningContentSession = JSON.parse(localStorage.getItem('learningContent'));
    const rowsPerPage = 5;
    const [page, setPage] = React.useState(1);

    const handlePageChange = (event, value) => setPage(value);

    const selectLearningContent = (learningContentId, isAccessible, isRecommended, isCompleted,isSecretCodeClaim) => {
        const learningContent = {
            learningContentCategoryId: learningContentSession.learningContentCategoryId,
            learningContentCategoryName: learningContentSession.learningContentCategoryName,
            learningContentId,
            isAccessible,
            isRecommended,
            isCompleted,
            isSecretCodeClaim
        };
        removeLearningContentFromSession();
        setLearningContentSession(JSON.stringify(learningContent));
        history.push("/LearningContent");
    }

    return (
        <>
            {
                learningContentsContext &&
                <Grid item xs={12} classes={{ root: classes.rootGridContainer }}>
                    <Accordion
                        classes={{
                            root: classes.rootAccordion,
                            rounded: classes.roundedAccordion
                        }}
                    >
                        <AccordionSummary
                            classes={{
                                root: classes.rootAccordionSummary,
                                content: classes.contentAccordionSummary,
                                expanded: classes.expandedAccordionSummary,
                                expandIcon: classes.expandIconAccordionSummary,
                            }}
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography classes={{ root: classes.rootContent }}>All Learning Resources</Typography>
                            <Typography classes={{ root: classes.rootContent }} className={classes.secondaryHeading}> Available: {learningContentsContext.availableLearningContentsCount} Completed : {learningContentsContext.completeCount}</Typography>
                        </AccordionSummary>
                        <AccordionDetails classes={{ root: classes.rootAccordionDetails }}>
                            {((learningContentsContext.learningContents).slice((page - 1) * rowsPerPage, page * rowsPerPage)).map((learningContent, idx) => (
                                <Grid
                                    item xs={12}
                                    key={idx}
                                    classes={{ root: classes.rootGridContainerLC }}
                                >
                                    <Accordion classes={{ root: classes.rootAccordion, rounded: classes.roundedAccordion }}>
                                        <AccordionSummary
                                            classes={{
                                                root: classes.rootAccordionSummary,
                                                content: classes.contentAccordionSummary,
                                                expanded: classes.expandedAccordionSummary,
                                                expandIcon: classes.expandIconAccordionSummary,
                                            }}
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography
                                                classes={{ root: classes.rootContentOthers }}
                                            >
                                                {learningContent.traitCategoryName}
                                            </Typography>
                                            <Typography
                                                classes={{ root: classes.rootContentOthers }}
                                                className={classes.secondaryHeading}
                                            >
                                                Available : {learningContent.availableContent} {' '}
                                                Completed : {learningContent.completedContents}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails classes={{ root: classes.rootAccordionDetails }}>
                                            {learningContent.triatLearningContents.map((item, idx) => (
                                                <Grid
                                                    style={{ backgroundColor: item.isTriedBefore ? 'transparent' : 'rgba(98, 197, 218, 0.5)' }}
                                                    key={idx}
                                                    container
                                                    classes={{ root: classes.rootGridItem }}
                                                    alignItems="center"
                                                    onClick={() => selectLearningContent(
                                                        item.learningContentId,
                                                        item.isAccessible,
                                                        item.isRecommended,
                                                        item.isCompleted,
                                                        item.isSecretCodeClaim
                                                    )}
                                                >
                                                    <Grid item xs={8}>
                                                        <Grid
                                                            container
                                                            alignItems="center"
                                                            justify="flex-start"
                                                        >
                                                            <div>
                                                                {
                                                                    item.isCompleted
                                                                        ?
                                                                        <Chip size="small" style={{ backgroundColor: '#4DD091', color: 'white' }}
                                                                            label={`Completed`} icon={<CheckCircleOutlineOutlinedIcon style={{ color: 'white' }} />}
                                                                        />
                                                                        :
                                                                        item.isTriedBefore ?
                                                                            <Chip size="small" style={{ backgroundColor: '#cd950c', color: 'white' }}
                                                                                label={`Ongoing`}
                                                                            />
                                                                            :
                                                                            <Chip size="small" style={{ backgroundColor: '#ff5768', color: 'white' }}
                                                                                label={`New`}
                                                                            />
                                                                }
                                                                {
                                                                    '  '
                                                                }
                                                                {
                                                                    item.isRecommended && !item.isCompleted ?
                                                                        <Tooltip title="Recommended Learning Content" aria-label="add">
                                                                            <Chip size="small" style={{ backgroundColor: '#098EAC' }}
                                                                                icon={<LoyaltyOutlinedIcon style={{ color: 'white' }} />}
                                                                            />
                                                                        </Tooltip>
                                                                        : <></>
                                                                }
                                                            </div>
                                                            <div className={classes.learningContentTitle}>{item.learningContentName}</div>

                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Grid container alignItems="center" justify="flex-end">
                                                            <div className={classes.rewardContainer}>
                                                                <Coin
                                                                    coin={!item.isCompleted && item.isTriedBefore ? item.rewardPoint / 2 : item.rewardPoint}
                                                                    // coin = {getLearningContentLevel() < 1 ? 0 : item.isCompleted ? item.rewardPoint / 2 : item.rewardPoint}
                                                                    size="medium"
                                                                />
                                                            </div>
                                                            <div className={classes.iconContainer}>
                                                                <NavigateNextIcon />
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            ))}
                        </AccordionDetails>

                        {
                            <Grid
                                container
                                direction={'row'}
                                alignContent={'center'}
                                justify={'center'}
                                classes={{ root: classes.rootGridPagination }}
                            >
                                <Pagination count={Math.ceil(learningContentsContext.learningContents.length / rowsPerPage)}
                                    variant="outlined"
                                    shape="rounded"
                                    color="secondary"
                                    page={page}
                                    onChange={handlePageChange}
                                    hidePrevButton hideNextButton />
                            </Grid>
                        }
                    </Accordion>
                </Grid>
            }
        </>
    );
};

export default LearningContentsHolder;

//<Grid
//    classes={{
//        root: classes.learningContentTitle,
//        root: item.isRecommended && classes.recommendedLC
//    }}
//>
//    <Grid container alignItems="center">
//        <div className={classes.containerName}>
//            {item.learningContentName}
//        </div>
//        {
//            item.isRecommended &&
//            <div className={classes.containerImage}>
//                <img src={getIconLearningContent().ic_lc_recommend} />
//            </div>
//        }
//    </Grid>
//</Grid>